import { api } from '../index';

const prefix = '/api/basic_info/salesgroup/';

export function apiIndex() {
	return api.get(prefix + 'index');
}

export function apiSelectSalesGroupList(param) {
	return api.post(prefix + 'selectSalesGroupList', param);
}

export function apiCheckSalesGroupExists(param) {
	return api.post(prefix + 'checkSalesGroupExists', param);
}

export function apiGetNewSalesGroupCode() {
	return api.get(prefix + 'getNewSalesGroupCode');
}

export function apiInsertSalesGroup(param) {
	param.mode = 'insert';
	return apiSubmitSalesGroup(param);
}

export function apiUpdateSalesGroup(param) {
	param.mode = 'update';
	return apiSubmitSalesGroup(param);
}

export function apiDeleteSalesGroup(param) {
	param.mode = 'delete';
	return apiSubmitSalesGroup(param);
}

function apiSubmitSalesGroup(param) {
	return api.post(prefix + 'submitSalesGroup', param);
}

export function apiSelectSalesBackupList(param) {
	return api.post(prefix + 'selectSalesBackupList', param);
}

export function apiInsertSalesBackups(param) {
	return api.post(prefix + 'insertSalesBackups', param);
}

export function apiDeleteSalesBackup(param) {
	return api.post(prefix + 'deleteSalesBackup', param);
}

export function selectAllSalesGroupList(param) {
	return api.get(prefix + 'allSelectSalesGroupList' + param);
}

export function apiUpdateSalesGroupList(sales_group_list) {
	return api.post(prefix + 'updateSalesGroupList', sales_group_list);
}
